<div class="scenario-rate">
    Сценарий клиента определен на
    <span :class="'percent text-' + getColorScenarioRate(scenarioRatings['Подбор товара'].percent)">
        {{scenarioRatings['Подбор товара'].percent}}%
    </span>.
</div>
